import { SchedulePartialStoreState, SCHEDULE_STATE_KEY } from '../schedule.reducer';

export const getTrips = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].onDemandTrips.trips;
export const getPolylines = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].onDemandTrips.polylines;
export const getSelectedTrip = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].onDemandTrips.selected;
export const getLoading = (state: SchedulePartialStoreState) => state[SCHEDULE_STATE_KEY].onDemandTrips.loading;
